import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { SovosTableCard, SovosTable } from 's1-ui';

const styles = {
  tableCardContainerStyles: {
    marginBottom: 50
  }
};

export class UnstyledLicenseTableCardDisplay extends React.Component {
  static propTypes = {
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    openDeleteModal: PropTypes.func.isRequired,
    sort: PropTypes.func.isRequired,
    sortedId: PropTypes.number,
    onEdit: PropTypes.func.isRequired,
    sortAscending: PropTypes.bool.isRequired
  };

  static defaultProps = {
    sortedId: undefined
  };

  editLicense = (license) => {
    this.props.onEdit(license.LicenseUid);
  }

  render() {
    const {
      rows, openDeleteModal, columns, sort, sortedId, sortAscending
    } = this.props;
    const actionArray = rows.map((license) => {
      license.actions = [{
        text: 'Delete',
        action: () => openDeleteModal(license)
      }];
      return license;
    });
    return (
      <div style={ styles.tableCardContainerStyles }>
        { rows.length > 0 && (
          <SovosTableCard className="CCP__LicenseTableCard__Display">
            <SovosTable
              columns={ columns }
              data={ actionArray }
              onRowClick={ this.editLicense }
              onColumnSort={ sort }
              sortedColumnId={ sortedId }
              columnSortProps={ {
                id: sortedId,
                isAscending: sortAscending
              } }
            />
          </SovosTableCard>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(UnstyledLicenseTableCardDisplay);
